import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const Shell = ({ title, children }) => (
  <div className="min-h-screen flex items-center justify-center bg-secondary/40 px-4">
    <div className="w-full max-w-sm bg-card border border-border rounded-sm p-8 space-y-5">
      <img src="/grcom-logo.png" alt="CV GRcom" className="h-10" />
      <h1 className="font-heading font-black text-2xl">{title}</h1>
      {children}
      <Link to="/login" className="block text-xs text-muted-foreground hover:text-foreground" data-testid="auth-back-login">← Kembali ke halaman masuk</Link>
    </div>
  </div>
);

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try { const { data } = await api.post("/auth/forgot-password", { email }); setMsg(data.message); }
    catch (e2) { setErr(formatApiErrorDetail(e2.response?.data?.detail) || "Gagal mengirim"); }
    setBusy(false);
  };
  return (
    <Shell title="Lupa Password">
      {msg ? <p className="text-sm" data-testid="forgot-success">{msg} Cek kotak masuk / spam email Anda.</p> : (
        <form onSubmit={submit} className="space-y-4">
          <div><Label>Email terdaftar</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" /></div>
          {err && <p className="text-xs text-red-600">{err}</p>}
          <Button type="submit" disabled={busy} className="w-full" data-testid="forgot-submit">{busy ? "Mengirim…" : "Kirim link reset"}</Button>
        </form>
      )}
    </Shell>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (pw !== pw2) return setErr("Konfirmasi password tidak sama");
    try { await api.post("/auth/reset-password", { token: params.get("token") || "", new_password: pw }); setDone(true); setTimeout(() => navigate("/login"), 2500); }
    catch (e2) { setErr(formatApiErrorDetail(e2.response?.data?.detail) || "Gagal menyimpan"); }
  };
  return (
    <Shell title="Buat Password Baru">
      {done ? <p className="text-sm" data-testid="reset-success">Password tersimpan. Mengalihkan ke halaman masuk…</p> : (
        <form onSubmit={submit} className="space-y-4">
          <div><Label>Password baru</Label><Input type="password" required value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password" /></div>
          <div><Label>Ulangi password</Label><Input type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password-confirm" /></div>
          <p className="text-[11px] text-muted-foreground">Minimal 8 karakter, berisi huruf dan angka.</p>
          {err && <p className="text-xs text-red-600" data-testid="reset-error">{err}</p>}
          <Button type="submit" className="w-full" data-testid="reset-submit">Simpan Password</Button>
        </form>
      )}
    </Shell>
  );
}

export function ChangePasswordForm() {
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setMsg("");
    if (f.new_password !== f.confirm) return setErr("Konfirmasi password tidak sama");
    try { await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password }); setMsg("Password berhasil diganti."); setF({ current_password: "", new_password: "", confirm: "" }); }
    catch (e2) { setErr(formatApiErrorDetail(e2.response?.data?.detail) || "Gagal mengganti password"); }
  };
  return (
    <form onSubmit={submit} className="space-y-4 max-w-sm" data-testid="change-password-form">
      {[["current_password", "Password lama"], ["new_password", "Password baru"], ["confirm", "Ulangi password baru"]].map(([k, l]) => (
        <div key={k}><Label>{l}</Label><Input type="password" required value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`cp-${k}`} /></div>
      ))}
      <p className="text-[11px] text-muted-foreground">Minimal 8 karakter, berisi huruf dan angka.</p>
      {err && <p className="text-xs text-red-600" data-testid="cp-error">{err}</p>}
      {msg && <p className="text-xs text-emerald-600" data-testid="cp-success">{msg}</p>}
      <Button type="submit" data-testid="cp-submit">Simpan Password</Button>
    </form>
  );
}
